import useSWR from "swr";
import { useAuth } from "../components/context/auth/AuthState";

export const useUserCommunity = () => {
  const { currentUser } = useAuth();

  return useSWR(
    currentUser?.user_id
      ? ["/user/data", { user_id: currentUser.user_id }]
      : null
  );
};

export const useUserProfile = (userId) => {
  return useSWR(userId ? ["/user/read", { user_id: userId }] : null);
};
